import styled from 'styled-components/macro'

import { Container } from 'components/container'
import { mq } from 'styles/mq'
import MusicBg from './assets/Music_Pic.webp'

export const MusicButtons = styled(Container)`
  display: flex;
  flex-direction: column;
  margin: 3rem 0;
  justify-content: center;
  aspect-ratio: 5 / 4;
  max-height: 40rem;
  font-size: 2.7rem;
  background: url(${MusicBg}) center center / min(${7700 / 39}%, 100rem) auto
    no-repeat;

  ${mq.large} {
    margin: 8rem auto;
    max-height: none;
    max-width: 124rem;
    aspect-ratio: 1920 / 700;
    font-size: 4.1rem;
    background-size: 124rem auto;
  }

  ${Container} {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 1rem;
    width: max-content;

    ${mq.medium} {
      flex-direction: row;
      gap: var(--gap-size);
      width: auto;
    }
  }

  a {
    padding: 0.4em 0.8em 0.7em;
    line-height: 0.8;
    color: inherit;
    border-radius: 0.3em;
    background-color: var(--music-link-color);

    span {
      display: block;
    }

    span::after {
      content: '';
      display: inline-block;
      width: 3em;
      aspect-ratio: 120 / 52;
      margin: -0.2em -0.1em 0 0.14em;
      background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 120 52' fill='none'%3E%3Cpath d='M109.327 10.3547C101.357 17.6558 90.6973 20.8555 80.7339 19.9315C80.5455 19.8935 80.588 20.0677 80.6508 20.0693L94.1786 26.0593L100.342 39.7635C100.342 39.7635 100.515 39.9692 100.541 39.6574C99.5222 29.5945 102.385 18.6234 109.418 10.4457C109.418 10.4457 109.452 10.3911 109.418 10.3561C109.383 10.3211 109.329 10.3571 109.329 10.3571L109.327 10.3547Z' fill='%23343431'/%3E%3Cpath d='M0.390625 50.4587H70.5443L100.61 19.9277' stroke='%23343431' stroke-width='2'/%3E%3C/svg%3E")
        center center / contain no-repeat;
    }

    &:hover,
    &:focus {
      background-color: var(--theme-color);
    }
  }
`
